module.exports = __webpack_public_path__ + "static/media/model3_Mobile_BackgroundPic.fe33e139.jpg";